/** Teilbare Aufgabenbereiche; keine Editor- oder Detailmodule ins Startpaket ziehen. */
export const TASK_DETAIL_TABS = ['uebersicht', 'details', 'kommentare', 'verlauf', 'gestaltung'] as const;
export type TaskDetailTab = (typeof TASK_DETAIL_TABS)[number];
